import React, {useState} from "react";


import "../styles/CareerList.css";
import Footer from '../component/footer';
import { Link, useParams, useLocation, Routes, Route } from "react-router-dom";

const cdnURL = process.env.REACT_APP_CDN_URL;

const joblist = [
    // {   id: 1, 
    //     title:"Logistics Executive", 
    //     location:"HQ - Petaling Jaya, Selangor", 
    //     department:"Black Market", 
    //     level:"Leader Level", 
    //     description:[
    //         "Ensure all incoming and outgoing goods are consistent with the delivery order or packing list.",
    //         "Check and inspect incoming goods and ensure they are in an accurate quantity, type, and acceptable quality.",
    //         "Check all loading and unloading items to ensure items are completed and tallied.",
    //         "Loading, transporting and delivering items to customer place in safe and timely manner.",
    //         "Involve with product counting as required.",
    //         "Ensure standard operating procedures are always followed.",
    //         "Responsible for the maintenance and cleanliness of the vehicles used.",
    //         "To support event or requested delivery activities.",
    //         "As an event driver and to be part of the event crew team to manage event logistics and setup, actual event and post event.",
    //         "Assist in order processing / stocks preparation / maintaining of regularly scheduled report / filing system.",
    //         "Willing to accept and perform other ad-hoc tasks, responsibilities and duties that may be assigned by superior."
    //     ],
    //     requirement:[
    //         "Able to use basic Microsoft Office and Excel.",
    //         "Have good communication and time management skills.",
    //         "Punctual, alert and honest.", 
    //         "Responsible and courteous.",
    //         "Work as an active team member to complete team goals.",
    //         "Willing to work before or after working hours if necessary."
    //     ],
    //     qualification:[
    //         "Candidate must possess at least a SPM / Diploma in Supply Chain, Logistics, Warehouse or equivalent.",
    //         "1 to 3 years of working experience in warehouse / logistics / driver.",
    //         "Possess a valid Class D and GDL driving license.",
    //         "Possess own transportation and willing to travel."
    //     ]
    // }
]


function CareerList({joblist}){

    const [search, setSearch] = useState("");

    const handleChange = (e) => {
        setSearch(e.target.value);
    };

    return (
        <div className="careerlist-page" style={{backgroundImage: `url("${cdnURL}/images/career/bg_careers2.png")`}}>

            <div  className="pathlink">
                <Link className="nav-link prevlink" to="/">Home /</Link>
                <Link className="nav-link prevlink" to="/careers">Career /</Link>
                <Link className="nav-link currlink" to="">All Job</Link>
            </div>

            <div className="joblist">
                <div className="joblist-title">
                    <a>Find your next opportunity</a>
                </div>

                <div className="joblist-filter">
                    <div className="searchbar">
                        <input name="search" placeholder="Search" value={search} onChange={handleChange}/>
                    </div>
                    <div className="category">
                        <select>
                            <option value="Category">Category</option>
                            <option value="Internship">Internship</option>
                            <option value="Leader">Leader</option>
                            <option value="Management Trainee">Management Trainee</option>
                        </select>
                    </div>
                    <div className="jobtype">
                        <select>
                            <option value="Job Type"> Job Type</option>
                            <option value="All"> All</option>
                            <option value="Big Data & Strategic Marketing">Big Data & Strategic Marketing</option>
                            <option value="Black Market">Black Market</option>
                            <option value="Channel Marketing">Channel Marketing</option>
                            <option value="CSO Office">CSO Office</option>
                            <option value="Digital Business">Digital Business</option>
                            <option value="Finance">Finance</option>
                            <option value="Group CEO’s Office">Group CEO’s Office</option>
                            <option value="Group CFO’s Office">Group CFO’s Office</option>
                            <option value="HR & Admin">HR & Admin</option>
                            <option value="Legal">Legal</option>
                            <option value="Mobile Business">Mobile Business</option>
                            <option value="Mobile, Products & Services">Mobile, Products & Services</option>
                            <option value="Operations & Support">Operations & Support</option>
                            <option value="Payment">Payment</option>
                            <option value="Regulatory & Government Affairs">Regulatory & Government Affairs</option>
                            <option value="Retail">Retail</option>
                            <option value="Technical">Technical</option>
                            <option value="Transformation">Transformation</option>
                        </select>
                    </div>
                    <div className="location">
                        <select>
                            <option value="Location">Location</option>
                            <option value="HQ – Petaling Jaya, Selangor">HQ – Petaling Jaya, Selangor</option>
                            <option value="IOI City Mall, Putrajaya">IOI City Mall, Putrajaya</option>
                            <option value="Lotus Kajang, Selangor">Lotus Kajang, Selangor</option>
                            <option value="SPACE @ Sunway Pyramid (Petaling Jaya, Selangor)">SPACE @ Sunway Pyramid (Petaling Jaya, Selangor)</option>
                            <option value="SPACE @ Sunway Velocity (Kuala Lumpur)">SPACE @ Sunway Velocity (Kuala Lumpur)</option>
                            <option value="Union Artisan Coffee x SPACE @ Midvalley Megamall (Kuala Lumpur)">Union Artisan Coffee x SPACE @ Midvalley Megamall (Kuala Lumpur)</option>
                            <option value="XCC ICT Komtar (Komtar, Penang)">XCC ICT Komtar (Komtar, Penang)</option>
                            <option value="XCC Queensbay (Bayan Lepas, Penang)">XCC Queensbay (Bayan Lepas, Penang)</option>
                        </select>
                    </div>
                </div>

                <div className="joblist-grid">
                    {joblist.length > 0 ? (
                       joblist.map((d, i) => (
                        <div key={i} className="joblist-card" >
                            <h1 dangerouslySetInnerHTML={{ __html: d.title.toUpperCase() }} />
                            
                            <div className="jobdetail">
                                <h2 dangerouslySetInnerHTML={{ __html: d.location }} />
                                <h2 dangerouslySetInnerHTML={{ __html: d.department }} />
                                <h2 dangerouslySetInnerHTML={{ __html: d.level }} />
                            </div>

                            <div className="jobdescbtn">
                                <Link className="nav-link" to={`/careerlist/${d.id}`}> Read full job description </Link>
                                <img/>
                                <span className="apply">Apply Now</span>
                            </div>
                        </div>
                        ))
                    ): (
                        <div className="no-job">
                            <h1>No job opening available right now</h1>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

function CareerDetail({ joblist}) {

    const { jobId } = useParams();
    const job = joblist.find(j => j.id.toString() === jobId);

    if (!job) return <div>Job not found</div>;
  
    return (
        <div className="career-detail" style={{backgroundImage: `url("${cdnURL}/images/career/bg_careers3.png")`}}>
            <div  className="pathlink">
                <Link className="nav-link prevlink" to="/">Home /</Link>
                <Link className="nav-link prevlink" to="/careers">Career /</Link>
                <Link className="nav-link prevlink" to="/careerlist">All Job /</Link>
                <Link className="nav-link currlink" to="">{job.title} /</Link>
            </div>

            <div className="detailcontent">
                <h3 dangerouslySetInnerHTML={{ __html: job.title.toUpperCase() }} />
                            
                <div className="jobdetail2">
                    <h2 dangerouslySetInnerHTML={{ __html: job.location }} />
                    <h2 dangerouslySetInnerHTML={{ __html: job.department }} />
                    <h2 dangerouslySetInnerHTML={{ __html: job.level }} />
                </div>

                <div className="applybtn">
                    <Link className="apply-link" to={`/careerlist/${job.id}/apply`}>
                        Apply for this job
                    </Link>
                </div>

                <div className="jobcontent">
                    <h1>Job description</h1>
                        <ul>
                            {job.description.map((line, i) => (
                                <li key={i}>{line}</li>
                            ))}
                        </ul>
                </div>

                <div className="jobcontent">
                    <h1>Job Requirements</h1>
                        <ul>
                            {job.requirement.map((line, i) => (
                                <li key={i}>{line}</li>
                            ))}
                        </ul>
                </div>

                <div className="jobcontent">
                    <h1>Qualification</h1>
                        <ul>
                            {job.qualification.map((line, i) => (
                                <li key={i}>{line}</li>
                            ))}
                        </ul>
                </div>
            </div>
        </div>
    )
}

function CareerApply({ joblist}) {
    
    const { jobId } = useParams();
    const job = joblist.find(j => j.id.toString() === jobId);

     const [ContactInfo, setContactInfo] = useState(
        {
            'name': "",
            'email': "",
            'mobile': "",
            'message': "",
            'nationality': "",
            'address': "",
            'salary': "",
            'notice': "",
            'resume': "",
        }
    );

    const handleChange = (e) => {
        setContactInfo({ ...ContactInfo, [e.target.name]: e.target.value });
    };


    if (!job) return <div>Job not found</div>;

    return (
        <div className="career-applynow" style={{backgroundImage: `url("${cdnURL}/images/career/bg_careers3.png")`}}>
            <div  className="pathlink">
                <Link className="nav-link prevlink" to="/">Home /</Link>
                <Link className="nav-link prevlink" to="/careers">Career /</Link>
                <Link className="nav-link prevlink" to="/careerlist">All Job /</Link>
                <Link className="nav-link prevlink" to={`/careerlist/${jobId}`}>{job.title} /</Link>
                <Link className="nav-link currlink" to="">Apply Now</Link>
            </div>

            <div className="applycontent">
                <h4 className="applytitle">Apply for this job</h4>
                <h3 dangerouslySetInnerHTML={{ __html: job.title.toUpperCase() }} />
                            
                <div className="jobdetail2">
                    <h2 dangerouslySetInnerHTML={{ __html: job.location }} />
                    <h2 dangerouslySetInnerHTML={{ __html: job.department }} />
                    <h2 dangerouslySetInnerHTML={{ __html: job.level }} />
                </div>

                <h1>Fill your personal information</h1>
                
                <div className="onerow">
                    <div className="contactfield">
                        <a>Full Name</a>
                        <input name="name" placeholder="Full Name" value={ContactInfo.name} onChange={handleChange}/>
                    </div>
                    <div className="contactfield">
                        <a>Mobile Number</a>
                        <input name="mobile" placeholder="Mobile Number" value={ContactInfo.mobile} onChange={handleChange}/>
                    </div>
                </div>
                <div className="onerow">
                    <div className="contactfield">
                        <a>Email Address</a>
                        <input name="email" placeholder="Email Address" value={ContactInfo.email} onChange={handleChange}/>
                    </div>
                    <div className="contactfield">
                        <a>Nationality</a>
                        <input name="nationality" placeholder="Nationality" value={ContactInfo.nationality} onChange={handleChange}/>
                    </div>
                </div>
                <div className="onerow">
                    <div className="contactfield">
                        <a>Address</a>
                        <textarea name="address" placeholder="Address" value={ContactInfo.address} rows="5" onChange={handleChange}/>
                    </div>
                </div>
                <div className="onerow">
                    <div className="contactfield">
                        <a>Expected Salary (RM)</a>
                        <input name="salary" placeholder="RM" value={ContactInfo.salary} onChange={handleChange}/>
                    </div>
                    <div className="contactfield">
                        <a>Notice Period</a>
                        <input name="notice" placeholder="Notice Period" value={ContactInfo.notice} onChange={handleChange}/>
                    </div>
                </div>
                <div className="onerow">
                    <div className="contactfield">
                        <a>Attach Resume</a>
                        <textarea name="resume" placeholder="Upload Resume" value={ContactInfo.resume} rows="5" onChange={handleChange}/>
                    </div>
                </div>

                <span>By proceeding, I acknowledge that I have read, understood and agreed to the website’s Terms and Conditions & Privacy Policy. XOX DIGITAL may store your personal info for internal analysis use or related activities.</span>
            </div>
        </div>
    )
}

export default function CareerPage () {

    return (
        <div className="career-page">
            <Routes>
                <Route path="/" element={<CareerList joblist={joblist} />} />
                <Route path=":jobId" element={<CareerDetail joblist={joblist} />} />
                <Route path=":jobId/apply" element={<CareerApply joblist={joblist} />} />
            </Routes>
            
            <div style={{padding:"0px 5.208vw"}}>
                <Footer />
            </div>
        </div>
    );
};

// export default CareerList;